import 'css-chunksrc/client/scenes/milestoneRemoval/styles.scss';export default {
  "header": "_header_10j74_1",
  "group": "_group_10j74_5",
  "text": "_text_10j74_9",
  "name": "_name_10j74_14",
  "main": "_main_10j74_20",
  "buttons": "_buttons_10j74_27"
};